import { RelevantFileGroup } from "../interface/relevant-file";

/**
 * 关联文件配置
 * @remarks
 * 注意：
 * 1. 上方配置优先级高于下方，通过配置顺序实现贪婪匹配
 * 2. 此处的文件后缀需要带着前面的“.”符号
 */
export const RELEVANT_FILE: RelevantFileGroup[] = [
  { suffixes: [".ts", ".webcmp", ".webcmd"] }
];
